export enum TypographyMedium {
  Desktop = "Desktop",
  Mobile = "Mobile",
  Common = "Common"
}

export enum TypographyType {
  Headline1Special,
  Headline2Special,
  Headline1,
  Headline2,
  Headline3,
  Headline3Medium, // mobile only
  Headline4, // desktop only
  Headline5, // desktop only
  Headline5Medium, // desktop only
  Body1Semibold,
  Body1Medium,
  Body2Semibold,
  Body2Medium,
  Body2Regular,
  Body3Semibold,
  Body3Regular
}

export const typographyMap = {
  [TypographyType.Headline1Special]: {
    [TypographyMedium.Common]: {
      fontFeatureSettings: "--headline-special-font-feature-settings",
      letterSpacing: "--headline-special-letter-spacing",
      fontFamily: "--headline-special-font-family",
      fontStyle: "--headline-special-font-style",
      fontWeight: "--headline-special-font-weight"
    },
    [TypographyMedium.Desktop]: {
      fontSize: "--headline1-special-desktop-font-size",
      lineHeight: "--headline1-special-desktop-line-height"
    },
    [TypographyMedium.Mobile]: {
      fontSize: "--headline1-special-mobile-font-size",
      lineHeight: "--headline1-special-mobile-line-height"
    }
  },
  [TypographyType.Headline2Special]: {
    [TypographyMedium.Common]: {
      fontFeatureSettings: "--headline-special-font-feature-settings",
      letterSpacing: "--headline-special-letter-spacing",
      fontFamily: "--headline-special-font-family",
      fontStyle: "--headline-special-font-style",
      fontWeight: "--headline-special-font-weight"
    },
    [TypographyMedium.Desktop]: {
      fontSize: "--headline2-special-desktop-font-size",
      lineHeight: "--headline2-special-desktop-line-height"
    },
    [TypographyMedium.Mobile]: {
      fontSize: "--headline2-special-mobile-font-size",
      lineHeight: "--headline2-special-mobile-line-height"
    }
  },
  [TypographyType.Headline1]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style",
      fontWeight: "--headline1-font-weight",
      fontSize: "--headline1-font-size",
      lineHeight: "--headline1-line-height"
    }
  },
  [TypographyType.Headline2]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style"
    },
    [TypographyMedium.Desktop]: {
      fontWeight: "--headline2-desktop-font-weight",
      fontSize: "--headline2-desktop-font-size",
      lineHeight: "--headline2-desktop-line-height"
    },
    [TypographyMedium.Mobile]: {
      fontWeight: "--headline2-mobile-font-weight",
      fontSize: "--headline2-mobile-font-size",
      lineHeight: "--headline2-mobile-line-height"
    }
  },
  [TypographyType.Headline3]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style"
    },
    [TypographyMedium.Desktop]: {
      fontWeight: "--headline3-desktop-font-weight",
      fontSize: "--headline3-desktop-font-size",
      lineHeight: "--headline3-desktop-line-height"
    },
    [TypographyMedium.Mobile]: {
      fontWeight: "--headline3-mobile-font-weight",
      fontSize: "--headline3-mobile-font-size",
      lineHeight: "--headline3-mobile-line-height"
    }
  },
  [TypographyType.Headline3Medium]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style"
    },
    [TypographyMedium.Mobile]: {
      fontWeight: "--headline3-mobile-medium-font-weight",
      fontSize: "--headline3-mobile-medium-font-size",
      lineHeight: "--headline3-mobile-medium-line-height"
    }
  },
  [TypographyType.Headline4]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style"
    },
    [TypographyMedium.Desktop]: {
      fontWeight: "--headline4-font-weight",
      fontSize: "--headline4-font-size",
      lineHeight: "--headline4-line-height"
    }
  },
  [TypographyType.Headline5]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style"
    },
    [TypographyMedium.Desktop]: {
      fontWeight: "--headline5-font-weight",
      fontSize: "--headline5-font-size",
      lineHeight: "--headline5-line-height"
    }
  },
  [TypographyType.Headline5Medium]: {
    [TypographyMedium.Common]: {
      letterSpacing: "--headline-letter-spacing",
      fontFamily: "--headline-font-family",
      fontStyle: "--headline-font-style",
      fontWeight: "--headline5-medium-font-weight",
      fontSize: "--headline5-medium-font-size",
      lineHeight: "--headline5-medium-line-height"
    }
  },
  [TypographyType.Body1Semibold]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body1-semibold-font-weight",
      fontSize: "--body1-font-size",
      lineHeight: "--body1-line-height"
    }
  },
  [TypographyType.Body1Medium]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body1-medium-font-weight",
      fontSize: "--body1-font-size",
      lineHeight: "--body1-line-height"
    }
  },
  [TypographyType.Body2Semibold]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body2-semibold-font-weight",
      fontSize: "--body2-font-size",
      lineHeight: "--body2-line-height"
    }
  },
  [TypographyType.Body2Medium]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body2-medium-font-weight",
      fontSize: "--body2-font-size",
      lineHeight: "--body2-line-height"
    }
  },
  [TypographyType.Body2Regular]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body2-regular-font-weight",
      fontSize: "--body2-font-size",
      lineHeight: "--body2-line-height"
    }
  },
  [TypographyType.Body3Semibold]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body3-font-weight",
      fontSize: "--body3-font-size",
      lineHeight: "--body3-line-height"
    }
  },
  [TypographyType.Body3Regular]: {
    [TypographyMedium.Common]: {
      fontFamily: "--body-font-family",
      fontStyle: "--body-font-style",
      fontWeight: "--body3-regular-font-weight",
      fontSize: "--body3-font-size",
      lineHeight: "--body3-line-height"
    }
  }
};
